import React from 'react';
import '../../../assets/styles/containers/_scheduleInspection.scss';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const ScheduleMessage = (props) => {
    const { activeStep, ScheduleInspectionSteps, navigate, location } = props;
    return (
        <Grid>
            <div className="inspection-message">
                <Typography>
                    {' '}
                    <CheckCircleIcon />
                </Typography>
                <Typography>{activeStep === ScheduleInspectionSteps.length ? 'Your inspection has been scheduled!' : 'Your inspection has been saved as a draft.'}</Typography>
                <Typography>{activeStep === ScheduleInspectionSteps.length ? 'We will send a confirmation email to the client. For a history of emails sent to your client, check under “notifications” on the inspection detail page. ' : 'When you are ready to schedule the inspection, go to the inspection detail page and edit or add the missing fields. Once all necessary details are completed, a confirmation email will be sent to the client. '}</Typography>
            </div>
            <Typography className="inspection-message-action">
                <Button onClick={() => (location?.state?.calendar ? navigate('/calendar') : navigate('/dashboard'))} className="default-btn" varient="contained">
                    OK
                </Button>
            </Typography>
        </Grid>
    );
};

export default ScheduleMessage;
